import React from "react";
import SectionLoader from "./SectionLoader";

function SectionLoaderWrapper({ isLoading = false, children }) {
  return isLoading ? <SectionLoader /> : children;
}

export default SectionLoaderWrapper;
